var _excluded = ["match", "component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { ComposedElement } from '@prezly/story-content-format';
import { Fragment } from 'react';
import { createComponentsRenderersFromChildren } from "./lib.mjs";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function Selector(_ref) {
  var {
    nodes: rootNodes,
    children
  } = _ref;
  var renderers = createComponentsRenderersFromChildren(children);
  function renderNodes(nodes) {
    return nodes.map((node, index) => /*#__PURE__*/_jsx(Fragment, {
      children: renderNode(node)
    }, index));
  }
  function renderNode(node) {
    for (var _ref3 of renderers) {
      var {
          match,
          component: ComponentRenderer
        } = _ref3,
        extraProps = _objectWithoutProperties(_ref3, _excluded);
      if (match(node)) {
        return /*#__PURE__*/_jsx(ComponentRenderer, _objectSpread(_objectSpread({}, extraProps), {}, {
          node: node
          // eslint-disable-next-line react/no-children-prop
          ,
          children: ComposedElement.isComposedElement(node) ? renderNodes(node.children) : undefined
        }));
      }
    }
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Array.isArray(rootNodes) ? renderNodes(rootNodes) : renderNode(rootNodes)
  });
}